import * as THREE from 'three'
import Experience from './Experience.js'
import iPhone from './iPhone/iPhone.js'
import LoadingBar from './iPhone/LoadingBar.js'
import CalloutPoints from './iPhone/CalloutPoints.js'

export default class World
{
    constructor(_options)
    {
        this.experience = new Experience()
        this.config = this.experience.config
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.sceneReady = false

        this.setLights();
        this.setLoadingBar();
        this.setCalloutPoints();

        this.resources.on('groupEnd', (_group) =>
        {
            if(_group.name === 'base')
            {
                this.setiPhone()
            }

            window.setTimeout(() =>
            {
                this.sceneReady = true
            }, 2000)
        })
    }

    setLoadingBar() 
    {
        this.loadingBar = new LoadingBar();
    }

    setLights() 
    {
        const directionalLight = new THREE.DirectionalLight('#ffffff', 1)
        directionalLight.castShadow = true
        directionalLight.shadow.camera.far = 15
        directionalLight.shadow.mapSize.set(1024, 1024)
        directionalLight.shadow.normalBias = 0.05
        directionalLight.position.set(3, -3, - 4)
        this.scene.add(directionalLight)

        const directionalLight2 = new THREE.DirectionalLight('#ffffff', 1)
        directionalLight2.castShadow = true
        directionalLight2.shadow.camera.far = 15
        directionalLight2.shadow.mapSize.set(1024, 1024)
        directionalLight2.shadow.normalBias = 0.05
        directionalLight2.position.set(-3, 3,  4)
        this.scene.add(directionalLight2)
    }

    setiPhone()
    {
        this.iPhone = new iPhone()        
    }

    setCalloutPoints()
    {
        this.calloutPoints = new CalloutPoints();
    }

    resize()
    {
    }

    update()
    {
        if(this.iPhone)
            this.iPhone.update()

        if (this.sceneReady) 
            this.calloutPoints.update()
    }

    destroy()
    {
    }
}